import { FAILURE, REQUEST, SUCCESS } from '@constant/reducer-status'
import { TAG } from '@constant/tag'
import produce from 'immer'

const initialState = {
  data: [],
  status: false,
}

export default produce((draft, action) => {
  switch (action.type) {
    case TAG.GET:
      draft.data = []
      draft.status = REQUEST
      break
    case TAG.GET_SUCCESS:
      draft.data = action.payload.data
      draft.status = SUCCESS
      break
    case TAG.GET_FAILURE:
      draft.data = []
      draft.status = FAILURE
      break
  }
}, initialState)
